import Table from './src/Table'
import TableColumn from './src/TableColumn'
Table.install = function (Vue) {
  if (Table.install.installed) {
    return
  }
  Vue.component(Table.name, Table)
  Vue.component(TableColumn.name, TableColumn)
  Table.install.installed = true
}
export default Table
